import Box from '@mui/material/Box';
import { DataPartnerFeesAlert } from '@openx/components-core/lib/Alert/DataPartnerFeesAlert';
import { useResourceInfoContext } from '@openx/components-core/lib/Form/context/ResourceInfoContext';
import { Trans, useTranslation } from 'react-i18next';

export const MultiProviderAudienceAlert = () => {
  const { name: resourceName } = useResourceInfoContext();

  const { t } = useTranslation();

  if (!resourceName) {
    return null;
  }

  // The fees section is part of the deal form only, so the package form gets the text without the button.
  const isPackageContext = resourceName === 'package';

  return (
    <DataPartnerFeesAlert
      data-test="multi-partner-warning"
      actionLabel={isPackageContext ? undefined : t('go to OpenXSelect Data Partner Fees')}
      message={
        <Trans
          i18nKey={
            isPackageContext
              ? '<bold>Multi-Partner Audience</bold> attached. Additional fees apply for enabled Data Partners. Full details available during deal creation in <bold>Curated Deal Fees for Enabled Data Partners</bold> section.'
              : '<bold>Multi-Partner Audience</bold> attached. Additional fees apply for enabled Data Partners. Full details in <bold>Curated Deal Fees for Enabled Data Partners</bold> section above.'
          }
          components={{ bold: <Box component="span" sx={{ fontWeight: 'fontWeightBold' }} /> }}
        />
      }
    />
  );
};
